export const host = "https://lpapi.rinku.buzz"
